// add class on scroll nav
$(window).scroll(function(){
    if ($(this).scrollTop() > 50) {
       $('.global_header').addClass('newClass');
    } else {
       $('.global_header').removeClass('newClass');
    }
});

// Scroll down arrow 
  $(document).ready(function() {
    $("#down_arrow_icon").click(function() {
      $("html, body").animate({ scrollTop: $(window).scrollTop() + $(window).height() }, 800);
    });
  });


// Play icon on header
